var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShield = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0.088L18.963 0.088 18.963 26.1 0 26.1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "red"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C2D1EA",
    d: "M16.823 14.207c0 3.339-1.872 5.8-7.341 9.518-5.47-3.719-7.341-6.179-7.341-9.518V5.742c2.72-.289 4.897-1.214 7.34-3.104 2.444 1.89 4.622 2.815 7.342 3.104v8.465zM18.428 3.73C15.211 3.657 13 2.883 9.884.23 9.772.136 9.626.088 9.482.088c-.146 0-.29.048-.402.143C5.965 2.883 3.753 3.657.536 3.73.24 3.737 0 3.972 0 4.263v9.944c0 4.834 3.283 7.962 9.037 11.77.122.082.284.123.445.123.161 0 .322-.04.445-.122 5.753-3.809 9.036-6.937 9.036-11.771V4.263c0-.29-.24-.526-.535-.533z",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2D1EA",
    d: "M6.648 12.053c-.22-.19-.576-.187-.792.006l-.696.624c-.216.194-.213.507.007.697l2.864 2.472c.029.024.06.045.093.064.218.129.517.11.71-.06l5.003-4.398c.217-.192.217-.505 0-.696l-.703-.618c-.218-.192-.575-.192-.792 0l-3.916 3.443-1.778-1.534z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.747ae510.svg";
export { ForwardRef as ReactComponent };